import {
  Form, Input, Button,
} from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';

interface LoginFormProps {
  onSubmit: (data : { username: string, password: string }) => void,
  loading: boolean
}

function LoginForm({ onSubmit, loading } : LoginFormProps) {
  const { Item } = Form;

  const [form] = Form.useForm();

  const onFinish = () => {
    form.validateFields().then((values) => onSubmit(values));
  };

  return (
    <Form
      name="login-form"
      initialValues={{ remember: true }}
      onFinish={onFinish}
      form={form}
      layout="vertical"
      size="large"
    >
      <Item
        hasFeedback
        name="username"
        rules={[{ required: true, message: 'Enter a username' }, { type: 'email', message: 'Enter a valid email' }]}
      >
        <Input
          placeholder="Username"
          prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
        />
      </Item>

      <Item
        hasFeedback
        name="password"
        rules={[{ required: true, message: 'Enter a password' }]}
      >
        <Input.Password
          placeholder="**Password**"
          prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
        />
      </Item>

      <Item shouldUpdate>
        {() => (
          <Button
            block
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={!form.isFieldsTouched(true)
              || Boolean(form.getFieldsError().filter(({ errors }) => errors.length).length)}
            size="large"
          >
            Log in
          </Button>
        )}
      </Item>

    </Form>
  );
}

export default LoginForm;
